import React, { useState, useEffect, useContext, useMemo } from "react";
import "./Define.css";
import { TERMS, DEFINE_FORECAST_LABELS } from "../../config/terminology";
import {
   Grid,
   Box,
   Chip,
   TextField,
   Typography,
   MenuItem,
   Button,
   Divider,
   Backdrop,
   CircularProgress,
   Dialog,
   DialogTitle,
   DialogContent,
   DialogActions,
   IconButton,
   Paper,
   Stack,
   FormControl,
   InputLabel,
   Select,
   Checkbox,
   ListItemText,
   OutlinedInput,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector, useDispatch } from "react-redux";
import DefineQuotaChart from "./DefineQuotaChart";
import DefineQuotaBreakdown from "./DefineQuotaBreakdown";
import SharedComponent from "./SharedComponent";
import ExportData from "./ExportData";
import {
   SaveOutlined,
   DrawRounded,
   TaskAltOutlined,
   DownloadOutlined,
   UploadOutlined,
   Close,
   UploadFile,
   TaskAltRounded,
   SpeakerNotesOutlined,
   DoNotDisturbOutlined,
} from "@mui/icons-material";
import Dropzone from "react-dropzone";
import Draggable from "react-draggable";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Comments from "./comments";
import FileAttach from "./FileAttach";
import Attachments from "./Attachments";
import CollapseSection from "../../components/ui/CollapseSection";
import {
   GetUserCountries,
   GetScenarioforQuotaDefinition,
   GetQuotaPeriods,
   GetQuotaDetails,
   GetQuotaChartData,
   setSelectedCountry,
   setSelectedScenario,
   setSelectedPeriod,
   setForecast,
   setQuotaCopy,
   setTimeDepletion,
   GetWeeklyDepletion,
   GetForecastDrivers,
   setForecastDriver,
   setForecastDriverParameters,
   setSelectProduct,
   setRounder,
   setApplyRounder,
   setSafetyMargin,
   setBufferAdjustment,
   setApplySafetyMargin,
   GetSKUOrPGByScenario,
   setTotalValues,
   setWeekPercent,
   setWeekPercentDepletion,
   GetWeeklyDepletionValues,
   setLoadData,
   reset,
   ExportExcel,
   ImportExcel,
   setQuotaObject,
   SaveQuota,
   Upload,
   SubmitQuota,
   DownloadFile,
   setState,
   setApplyBufferAdjustment,
} from "./defineSlice";
import ViewSearchRefresh from "./ViewSearchRefresh";
import DefineQuotaTable from "./DefineQuotaTable";
import ChartTableToggle from "./ChartTableToggle";
import { formatNumber, removeComma, getForecastDriverNames, getForecastParametersForDriver } from "./defineUtils";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import { deleteExistingFile } from "./defineSlice";
import ExportDataModal from "./ExportDataModal";
import {useInView} from 'react-intersection-observer';
import Avatar from "@mui/material/Avatar";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

function PaperComponent(props) {
   return (
      <Draggable
         handle="#draggable-dialog-title"
         cancel={'[class*="MuiDialogContent-root"]'}
      >
         <Paper {...props} />
      </Draggable>
   );
}

const criticalities = [
   { key: 0, value: "None" },
   { key: 1, value: "Low" },
   { key: 2, value: "Medium" },
   { key: 3, value: "High" },
   { key: 4, value: "Severe" },
   { key: 5, value: "Other" },
];

function DefineQuota() {
   const autherization = localStorage.getItem("data");
   const data = JSON.parse(autherization);
   let setAccess = true;
   if (data?.restrictedAccess == 0) setAccess = true;
   else setAccess = false;
   const isRestrictedAccess = setAccess;
   const dispatch = useDispatch();
   const define = useSelector((state) => state.define);
   const {
      isLoading,
      countries,
      selectedCountry,
      scenarioList,
      selectedScenario,
      quotaPeriods,
      weeklyDepletionList,
      selectedPeriod,
      selectedQuota,
      loadQuotaDetails,
      loadQuotaChart,
      selectedDepletion,
      listProduct,
      selectedProduct,
      ForecastAdjustment,
      TotalAdjustment,
      TotalSafetyMargin,
      TotalUnusedQuota,
      TotalQuota,
      rounder,
      initialForecast,
      revisedQuota,
      onSubmitDisabled,
      forecastType,
      commonSafetyMargin,
      bufferAdjustment,
      quotaCopy,
      isNavigate,
      filter_customerTypes,
      filter_customerTrustLevels,
      gridData,
      filter_skuName,
      searchText,
      TotalTender,
      forecastDrivers,
      selectedForecastDriver,
      selectedForecastDriverParameterIds,
   } = define;

   const forecastDriverOptions = useMemo(
      () => getForecastDriverNames(forecastDrivers),
      [forecastDrivers]
   );

   const forecastParameterOptions = useMemo(
      () =>
         getForecastParametersForDriver(
            forecastDrivers,
            selectedForecastDriver
         ),
      [forecastDrivers, selectedForecastDriver]
   );

   const loginState = useSelector((store) => store.login);
   const { globalSelectedCountryName,globalSelectedCountryID,} = loginState  
   
   useEffect(() => {
		if(globalSelectedCountryID !== null){
      const fetchDataSequently=async()=>{
         await dispatch(GetUserCountries({ method: "Get" })); 
         dispatch(setSelectedCountry(globalSelectedCountryID));         
      }
      fetchDataSequently();
      dispatch(setState("DGlobalCountryID", globalSelectedCountryID));  
      dispatch(GetScenarioforQuotaDefinition({ method: "GET", countryId: globalSelectedCountryID }));  
		}
	},[globalSelectedCountryID])   

   const {ref: topBoxRef, inView} = useInView({
      threshold: 0.01,
      triggerOnce: false,
      rootMargin: "-25px 0px 0px 0px",
   });


   useEffect(()=>{
      dispatch(setState("showMiddleBox", !inView));
   },[inView])

   const [open, setOpen] = useState(false);
   const [selectedFiles, setSelectedFiles] = useState(undefined);
   const [currentFile, setCurrentFile] = useState(undefined);

   useEffect(() => {
      if (!isNavigate) {
         dispatch(reset("onRefresh"));
         dispatch(GetUserCountries({ method: "Get" }));
         dispatch(GetForecastDrivers({ method: "GET" }));
      } else {
         dispatch(reset("onRefresh"));
         dispatch(setState("isNavigate", false));
      }
   }, []);

   const handleCountryChange = (e) => {
      let v = e.target.value;
      dispatch(setState("selectedRows", []));
      dispatch(setSelectedCountry(v));
      dispatch(reset("countryChange"));
      dispatch(GetScenarioforQuotaDefinition({ method: "GET", countryId: v }));
      // dispatch(GetScenarioforQuotaDefinition({ method: "GET", countryId: id })).then(() => {
      //     dispatch(GetQuotaPeriods({ method: "GET"}));
      // });
   };

   const handleScenarioChange = (e) => {
      let v = e.target.value;
      //dispatch(setState("selectedRows", []));
      dispatch(setSelectedScenario(v));
      //dispatch(reset("scenarioChange"));
      //dispatch(GetQuotaPeriods({ method: "GET", scenarioID: v }));
      //dispatch(GetWeeklyDepletion({ method: "GET" }));
   };

   useEffect(() => {
      if (selectedScenario.scenarioID) {
         dispatch(setState("selectedRows", []));
         dispatch(reset("scenarioChange"));
         dispatch(setState("hideWeekColumns", selectedScenario.periodType === "Monthly" ? true : false));
         dispatch(GetQuotaPeriods({ method: "GET", scenarioID: selectedScenario.scenarioID }));
         dispatch(GetWeeklyDepletion({ method: "GET" }));
      }
   }, [selectedScenario])


   const handlePeriodChange = (e) => {
      dispatch(reset("onPeriodChange"));
      let v = e.target.value;
      dispatch(setState("selectedRows", []));
      dispatch(setSelectedPeriod(v));
      dispatch(GetWeeklyDepletion({ method: "GET" }));
   };

   const handleRetrive = () => {
      dispatch(setState("gridDataChanged", false));
      if (
         selectedCountry.countryID === undefined ||
         selectedCountry.countryID === null
      ) {
         showMessage("Please select a country", "info");
      } else if (
         selectedScenario.scenarioID === undefined ||
         selectedScenario.scenarioID === null
      ) {
         showMessage("Please select a scenario", "info");
      } else if (
         selectedPeriod.startDate === undefined ||
         selectedPeriod.startDate === null
      ) {
         showMessage("Please select a validity period", "info");
      } else {
         dispatch(setState("filter_customerTypes", []));
         dispatch(setState("filter_customerTrustLevels", []));
         dispatch(setState("filter_skuName", []));
         dispatch(setState("filter_skuNumber", []));
         dispatch(setState("selectedRows", []));

         dispatch(reset("onRetriveClick"));
         let queryParams =
            "scenarioId=" +
            selectedScenario.scenarioID +
            "&startDate=" +
            selectedPeriod.startDate +
            "&endDate=" +
            selectedPeriod.endDate +
            "&countryId=" +
            selectedCountry.countryID +
            "&breakdown=" +
            false;

         dispatch(GetForecastDrivers({ method: "GET" })).then(() => {
            dispatch(
               GetQuotaDetails({ method: "GET", queryParams: queryParams })
            ).then((response) => {
               dispatch(setTotalValues());
               dispatch(GetSKUOrPGByScenario({ method: "GET" })).then(() => {
                  if (
                     selectedDepletion.key !== "None" ||
                     response.previousPeriodDepletionModel !== "None"
                  ) {
                     dispatch(GetWeeklyDepletionValues({ method: "GET" })).then(
                        () => {
                           dispatch(setTotalValues());
                           dispatch(setLoadData());
                           dispatch(GetQuotaChartData({ method: "POST" }));
                        }
                     );
                  } else {
                     dispatch(setWeekPercent());
                     dispatch(setLoadData());
                     dispatch(GetQuotaChartData({ method: "POST" }));
                  }
               });
            });
         });
      }
   };
   const showMessage = (message, severity) => {
      dispatch(setState("isFailed_Info", message));
      dispatch(setState("isFailed", true));
   };
   const onSubmit = (values) => { };

   const handleForecastType = () => { };

   const refreshQuotaChart = () => {
      dispatch(setLoadData());
      dispatch(GetQuotaChartData({ method: "POST" }));
   };

   const handleQuotaCopy = (e) => {
      let v = e.target.value;
      v = removeComma(v);
      dispatch(setQuotaCopy(v));
   };

   const handleForecastDriverChange = (e) => {
      dispatch(setForecastDriver(e.target.value));
      refreshQuotaChart();
   };

   const handleForecastDriverParametersChange = (e) => {
      const value = e.target.value;
      const ids = typeof value === "string" ? value.split(",") : value;
      dispatch(
         setForecastDriverParameters(ids.map((id) => Number(id)).filter((id) => !Number.isNaN(id)))
      );
      refreshQuotaChart();
   };

   const handleForecast = (e) => {
      let v = e.target.value;
      v = removeComma(v);
      dispatch(setForecast(v));
   };

   const handleTimeDepletion = (e) => {
      let v = e.target.value;
      dispatch(setTimeDepletion(v));
      //dispatch(GetWeeklyDepletionValues({ method: "GET" }));
      handleAllocate();
   };
   const handleAllocate = () => {
      dispatch(setState("gridDataChanged", true));
      dispatch(reset("onAllocateClick"));
      let queryParams =
         "scenarioId=" +
         selectedScenario.scenarioID +
         "&startDate=" +
         selectedPeriod.startDate +
         "&endDate=" +
         selectedPeriod.endDate +
         "&countryId=" +
         selectedCountry.countryID +
         "&breakdown=" +
         true;
      dispatch(
         GetQuotaDetails({ method: "GET", queryParams: queryParams })
      ).then(() => {
         // if (selectedDepletion.key !== "None") {
         console.log("Define_selectedDepletion", selectedDepletion);
         dispatch(GetWeeklyDepletionValues({ method: "GET" })).then(() => {
            dispatch(setWeekPercentDepletion());
            dispatch(setLoadData());
            dispatch(GetQuotaChartData({ method: "POST" }));
         });
         // this.showWeekColumns = true;
         //} else {
         // this.showWeekColumns = false;
         //    dispatch(setWeekPercentDepletion());
         //    dispatch(setLoadData());
         //    dispatch(GetQuotaChartData({ method: "POST" }));
         // }
      });
   };

   const handleSelectProduct = (e) => {
      dispatch(setState("selectedRows",[]));
      let v = e.target.value;
      dispatch(reset("onProductChange"));
      dispatch(setSelectProduct(v));
      dispatch(setLoadData());
      dispatch(GetQuotaChartData({ method: "POST" }));
      let val = gridData?.filter((item) => {
         return (
            (filter_customerTypes.length === 0 || filter_customerTypes.some(type => item.type.toLowerCase().includes(type.toLowerCase()))) &&
            (filter_customerTrustLevels.length === 0 || filter_customerTrustLevels.some(level => item.customerTrustLevel.toLowerCase().includes(level.toLowerCase()))) &&
            (filter_skuName.length === 0 || filter_skuName.some(sku => item.skuName.toLowerCase().includes(sku.toLowerCase()))) &&
            (v === 0 || v === undefined || item.skuid === v || item.productGroupID === v) &&
            (item.skuName?.toLowerCase().includes(searchText) ||
               item.skuNumb?.toLowerCase().includes(searchText) ||
               item.customerName?.toLowerCase().includes(searchText) ||
               item.customerGroupName?.toLowerCase().includes(searchText) ||
               item.customerNumber?.toLowerCase().includes(searchText))
         );
      });
      dispatch(setState("gridDataFiltered", val));
      // dispatch(GetQuotaChartData({ method: "POST" }));
   };

   const handleRounder = (e) => {
      let v = e.target.value;
      v = removeComma(v);
      dispatch(setRounder(v));
   };
   const handleSafetyMargin = (e) => {
      let v = e.target.value;
      v = removeComma(v);
      if(v === "0-") {
         v = "-";
      }
      dispatch(setSafetyMargin(v));
   };
   const handleBufferAdjustment = (e) => {
      let v = e.target.value;
      v = removeComma(v);
      if(v === "0-") {
         v = "-";
      }
      dispatch(setBufferAdjustment(v));
   };

   const applyRounder = () => {
      dispatch(setState("gridDataChanged", true));
      dispatch(setState("isLoading", true));
      let timeout = setTimeout(() => {
         dispatch(reset("onApplyRounder"));
         //dispatch(setApplySafetyMargin());
         //dispatch(setApplyBufferAdjustment());
         dispatch(setApplyRounder());
         dispatch(setTotalValues());
         dispatch(setLoadData());
         dispatch(GetQuotaChartData({ method: "POST" }));
      }, 10);
      return () => clearTimeout(timeout);
   };

   const applySafetyMargin = () => {
      dispatch(setState("gridDataChanged", true));
      dispatch(setState("isLoading", true));
      let timeout = setTimeout(() => {
         dispatch(reset("onApplyRounder"));
         dispatch(setApplySafetyMargin());
         dispatch(setTotalValues());
         dispatch(setLoadData());
         dispatch(GetQuotaChartData({ method: "POST" }));
      }, 10);
      return () => clearTimeout(timeout);
   }

   const applyBufferAdjustment = () => {
      dispatch(setState("gridDataChanged", true));
      dispatch(setState("isLoading", true));
      let timeout = setTimeout(() => {
         dispatch(reset("onApplyRounder"));
         dispatch(setApplyBufferAdjustment());
         dispatch(setTotalValues());
         dispatch(setLoadData());
         dispatch(GetQuotaChartData({ method: "POST" }));
      }, 10);
      return () => clearTimeout(timeout);
   }
   const handleDownloadQuota = () => {
      dispatch(setQuotaObject({ method: "excelDownload" }));
      dispatch(ExportExcel({ method: "POST" }));
   };

   const handleUploadQuota = () => {
      setOpen(true);
   };

   const handleClose = () => {
      setSelectedFiles("");
      setOpen(false);
   };

   const onDrop = (files) => {
      console.log("onDrop files", files);
      if (files.length > 0) {
         setSelectedFiles(files);
      }
   };

   const handleProcess = () => {
      dispatch(setState("gridDataChanged", true));
      dispatch(reset("onImportExcel"));
      let currentFile = selectedFiles[0];
      setCurrentFile(currentFile);
      setSelectedFiles("");
      let formData = new FormData();
      formData.append("files", currentFile);
      dispatch(ImportExcel({ method: "POST", body: formData })).then(() => {
         dispatch(setTotalValues());
         dispatch(setLoadData());
         dispatch(GetQuotaChartData({ method: "POST" }));
      });
      setOpen(false);
   };

   const handleSaveQuota = () => {
      dispatch(setState("gridDataChanged", false));
      dispatch(Upload({ method: "POST" })).then(() => {
         dispatch(setQuotaObject({ method: "saveQuota" }));
         dispatch(SaveQuota({ method: "POST" })).then((response) => {
            if (response.payload !== "error") {
               dispatch(reset("onAllocateClick"));
               dispatch(setLoadData());
               dispatch(GetQuotaChartData({ method: "POST" }));
            }
         });
         dispatch(setState("saveOrSubmitError", 0));
      });
   };

   const handleSubmitQuota = () => {
      dispatch(setState("gridDataChanged", false));
      dispatch(Upload({ method: "POST" })).then(() => {
         dispatch(setQuotaObject({ method: "submitQuota" }));
         dispatch(SubmitQuota({ method: "POST" })).then((response) => {
            if (response.payload !== "error") {
               handleRetrive();
            }
         });
         dispatch(setState("saveOrSubmitError", 0));
      });
   };

   const handleDownloadFile = (filepath) => {
      dispatch(DownloadFile(filepath));
   };

   function handleDeleteFile(file) {
      console.log(file);
      dispatch(deleteExistingFile(file));
   }

   return (
      <Box>
         <Box sx={{ position: 'sticky', top: 65, backgroundColor: 'white !important', width: '100%', zIndex: 1000  }}>
         <Typography variant="subtitle1" my={2} sx={{mt: 2}}>
            Search for Scenario
         </Typography>
         {/* <form onSubmit={handleSubmit(onSubmit)}> */}
         {/* <Box className="scenario-search"> */}
         <Grid
            container
            columns={12}
            justifyContent="flex-start"
            alignItems="center"
            spacing={3}
            pb={1}
            sx={{ mb: 2 }}
         >
            <Grid item xs={12} sm={6} md={2.9} lg={2.9}>
               <TextField
                  variant="outlined"
                  label="Country"
                  select={countries.length > 0 ? true : false}
                  //value={countries.length > 0 ? selectedCountry.countryID : " "}
                  value={countries.length > 0 ? selectedCountry.countryID : " "}
                  onChange={handleCountryChange}
                  fullWidth
                  size="small"
               // disabled={countries.length > 0 ? false : true}
               // {...register("country", {
               //     required: "Please select a country",
               // })}
               // error={Boolean(errors.country)}
               // helperText={errors ?.country ?.message}
               >
                  {countries.length > 0
                     ? countries.map((country, index) => {
                        return (
                           <MenuItem
                              key={country.countryID}
                              value={country.countryID}
                           >
                              {country.countryName}
                           </MenuItem>
                        );
                     })
                     : null}
               </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
               <TextField
                  variant="outlined"
                  label="Scenario"
                  select={scenarioList.length > 0 ? true : false}
                  value={
                     scenarioList.length > 0 ? selectedScenario.scenarioID : ""
                  }
                  onChange={handleScenarioChange}
                  size="small"
                  fullWidth
                  disabled={scenarioList.length > 0 ? false : true}
               // required
               // {...register("scenario", {
               //     required: "Please select a scenario",
               // })}
               // error={Boolean(errors.scenario)}
               // helperText={errors ?.scenario ?.message}
               >
                  {scenarioList.length > 0
                     ? scenarioList.map((scenario, index) => {
                        return (
                           <MenuItem
                              key={scenario.scenarioID}
                              value={scenario.scenarioID}
                           >
                              {scenario.scenarioName}
                           </MenuItem>
                        );
                     })
                     : null}
               </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={4}>
               <TextField
                  variant="outlined"
                  label="Validity Period"
                  select={quotaPeriods.length > 0 ? true : false}
                  value={
                     quotaPeriods.length > 0 ? selectedPeriod.displayDate : ""
                  }
                  onChange={handlePeriodChange}
                  size="small"
                  fullWidth
                  disabled={quotaPeriods.length > 0 ? false : true}
               // {...register("currentPeriod", {
               //     required: "Please select validity period.",
               // })}
               // error={Boolean(errors.currentPeriod)}
               // helperText={errors ?.currentPeriod ?.message}
               >
                  {quotaPeriods.length > 0
                     ? quotaPeriods.map((quota, index) => {
                        return (
                           <MenuItem
                              key={quota.displayDate}
                              value={quota.displayDate}
                           >
                              {quota.displayDate}
                           </MenuItem>
                        );
                     })
                     : null}
               </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={1}>
               <Box justifyContent="center" display="flex">
                  <Button
                     sx={{
                        bgcolor: "darkBlue.light",
                        color: "white.main",
                        fontWeight: "700",
                        textTransform: "none",
                        "&:hover": {
                           bgcolor: "darkBlue.main",

                        },
                     }}
                     startIcon={<SearchIcon />}
                     variant="contained"
                     onClick={handleRetrive}
                     size="large"
                  >
                     Retrieve
                  </Button>
               </Box>
            </Grid>
         </Grid>
         </Box>
         {loadQuotaDetails && (
            <>
               <CollapseSection sx={{ mt: 2 }} title="Commercial Forecast Analysis">
                  <Grid
                     container
                     columns={12}
                     justifyContent="space-between"
                     alignItems="center"
                     spacing={2}
                     sx={{ paddingTop: "10px", paddingLeft: "10px" }}
                  >
                     <Grid item xs={12} sm={6} md={8} lg={9}>
                        <Box sx={{ display: 'flex', justifyContent: 'align-start', alignItems: 'center' }}>
                           <Typography variant="subtitle1" sx={{ display: "inline", mr: 2 }}>
                              {`${selectedScenario?.scenarioName}`}{"  "}
                           </Typography>
                           <Typography variant="p14w500" sx={{ backgroundColor: "#efefef", p: 1, py: 1, pl: 1, borderRadius: "30px 30px 30px 30px" }}>
                              {`Criticality: `}
                              <b>{criticalities.find(
                                 (item) =>
                                    item.key === selectedScenario.criticalityId
                              ).value
                              }</b>
                           </Typography>
                        </Box>
                     </Grid>
                     <Grid item xs={12} sm={3} md={2} lg={2} ref = {topBoxRef}>
<Typography variant="subtitle1">
                                           {TERMS.QUOTA} status
                           <Chip
                              icon={
                                 (selectedQuota?.quotaStatus === "Approved" && (
                                    <TaskAltRounded />
                                 )) ||
                                 (selectedQuota?.quotaStatus ===
                                    "Locally Approved" && <TaskAltRounded />) ||
                                 (selectedQuota?.quotaStatus === "Draft" && (
                                    <DrawRounded />
                                 )) ||
                                 (selectedQuota?.quotaStatus === "Submitted" && (
                                    <DrawRounded />
                                 )) ||
                                 (selectedQuota?.quotaStatus === "Rejected" && (
                                    <DrawRounded />
                                 )) ||
                                 (selectedQuota?.quotaStatus === "Invalid" && (
                                    <DrawRounded />
                                 )) ||
                                 ((selectedQuota?.quotaStatus === null ||
                                    selectedQuota?.quotaStatus === " ") && (
                                       <DoNotDisturbOutlined />
                                    ))
                              }
                              label={
                                 selectedQuota?.quotaStatus === null ||
                                    selectedQuota?.quotaStatus === " "
                                    ? "N/A"
                                    : selectedQuota?.quotaStatus
                              }
                              color={
                                 (selectedQuota?.quotaStatus === "Approved" &&
                                    "success") ||
                                 (selectedQuota?.quotaStatus ===
                                    "Locally Approved" &&
                                    "success") ||
                                 (selectedQuota?.quotaStatus === "Draft" &&
                                    "info") ||
                                 (selectedQuota?.quotaStatus === "Submitted" &&
                                    "info") ||
                                 (selectedQuota?.quotaStatus === "Rejected" &&
                                    "error") ||
                                 (selectedQuota?.quotaStatus === "Invalid" &&
                                    "error") ||
                                 ((selectedQuota?.quotaStatus === null ||
                                    selectedQuota?.quotaStatus === " ") &&
                                    "error")
                              }
                              variant="outlined"
                              size="small"
                              sx={{ ml: 1, p: 1 }}
                           />
                        </Typography>
                     </Grid>
                     <Grid item xs={12} sm={3} md={2} lg={1}>
                        <ExportData />
                     </Grid>
                  </Grid>

                  <ExportDataModal />

                  <Divider sx={{ margin: "16px 0" }} />
                  <Grid container
                     columns={12}
                     justifyContent="space-between"
                     alignItems="center"
                     spacing={2}
                     pb={1}
                  >
                     <Grid item xs={12} sm={12} md={2.5} lg={2} sx={{ mt: 2 }}>
                        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 2 }}>
                           <TextField
                              variant="outlined"
                              readOnly={true}
                              label="Forecast Type"
                              value={forecastType}
                              //select={countries.length > 0 ? true : false}
                              //value={countries.length > 0 ? selectedCountry.countryID : " "}
                              onChange={handleForecastType}
                              fullWidth
                              size="small"
                           //disabled={countries.length > 0 ? false : true}
                           >
                              {/* {countries.length > 0 ? (
                                countries.map((country, index) => {
                                    return (
                                        <MenuItem key={country.countryID} value={country.countryID}>
                                            {country.countryName}
                                        </MenuItem>
                                    )
                                })) : null
                            } */}
                           </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 2 }}>
                           <TextField
                              disabled={true}
                              variant="outlined"
                              label={DEFINE_FORECAST_LABELS.UNCONSTRAINED}
                              readOnly={true}
                              value={initialForecast?.toLocaleString('en-US')}
                              onChange={handleForecast}
                              size="small"
                              fullWidth
                           ></TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 2 }}>
                           <TextField
                              variant="outlined"
                              label={DEFINE_FORECAST_LABELS.CONSTRAINED}
                              value={selectedQuota?.quotaCopy?.toLocaleString('en-US')}
                              onChange={handleQuotaCopy}
                              size="small"
                              fullWidth
                           ></TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 2 }}>
                           <TextField
                              variant="outlined"
                              select
                              label="Driver"
                              value={selectedForecastDriver}
                              onChange={handleForecastDriverChange}
                              size="small"
                              fullWidth
                              disabled={!loadQuotaDetails || forecastDriverOptions.length === 0}
                           >
                              <MenuItem value="">
                                 <em>Select driver</em>
                              </MenuItem>
                              {forecastDriverOptions.map((name) => (
                                 <MenuItem key={name} value={name}>
                                    {name}
                                 </MenuItem>
                              ))}
                           </TextField>
                        </Grid>
                        {selectedForecastDriver ? (
                           <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 2 }}>
                              <FormControl fullWidth size="small">
                                 <InputLabel id="forecast-driver-parameter-label">
                                    Driver parameter
                                 </InputLabel>
                                 <Select
                                    labelId="forecast-driver-parameter-label"
                                    multiple
                                    value={selectedForecastDriverParameterIds}
                                    onChange={handleForecastDriverParametersChange}
                                    input={<OutlinedInput label="Driver parameter" />}
                                    renderValue={(selected) => {
                                       const labels = forecastParameterOptions
                                          .filter((p) =>
                                             selected.includes(p.forecastDriverID)
                                          )
                                          .map((p) => p.driverParameter);
                                       if (labels.length === 0) {
                                          return "";
                                       }
                                       const extraCount = labels.length - 1;
                                       return (
                                          <Box
                                             sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                width: "100%",
                                                gap: 1,
                                             }}
                                          >
                                             <Box
                                                component="span"
                                                sx={{
                                                   overflow: "hidden",
                                                   textOverflow: "ellipsis",
                                                   whiteSpace: "nowrap",
                                                }}
                                             >
                                                {labels[0]}
                                             </Box>
                                             {extraCount > 0 ? (
                                                <Box
                                                   component="span"
                                                   sx={{
                                                      color: "text.secondary",
                                                      flexShrink: 0,
                                                   }}
                                                >
                                                   +{extraCount}
                                                </Box>
                                             ) : null}
                                          </Box>
                                       );
                                    }}
                                 >
                                    {forecastParameterOptions.map((param) => (
                                       <MenuItem
                                          key={param.forecastDriverID}
                                          value={param.forecastDriverID}
                                       >
                                          <Checkbox
                                             checked={selectedForecastDriverParameterIds.includes(
                                                param.forecastDriverID
                                             )}
                                          />
                                          <ListItemText primary={param.driverParameter} />
                                       </MenuItem>
                                    ))}
                                 </Select>
                              </FormControl>
                           </Grid>
                        ) : null}
                        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 2 }}>
										<TextField
											variant="outlined"
											label={`Unused ${TERMS.QUOTA}`}
											readOnly={true}
                                 disabled={true}
											value={TotalUnusedQuota?.toLocaleString('en-US')}
											size="small"
											fullWidth
										></TextField>
								</Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 2 }}>
                           <TextField
                              sx={{
                                 display:
                                    selectedScenario.periodType === "Monthly"
                                       ? "block"
                                       : "none",
                              }}
                              variant="outlined"
                              label="Time Depletion"
                              select={weeklyDepletionList.length > 0 ? true : false}
                              value={
                                 weeklyDepletionList.length > 0
                                    ? selectedDepletion?.value
                                    : ""
                              }
                              onChange={handleTimeDepletion}
                              size="small"
                              fullWidth
                              disabled={weeklyDepletionList.length > 0 ? false : true}
                           >
                              {weeklyDepletionList.length > 0
                                 ? weeklyDepletionList.map((item, index) => {
                                    return (
                                       <MenuItem key={item.key} value={item.value}>
                                          {item.value}
                                       </MenuItem>
                                    );
                                 })
                                 : null}
                           </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 2 }}>
                           <Box justifyContent="flex-end" display="flex" >
                              <Button
                                 sx={{
                                    bgcolor: "darkBlue.light",
                                    color: "white.main",
                                    fontWeight: "700",
                                    textTransform: "none",
                                    "&:hover": {
                                       bgcolor: "darkBlue.main",

                                    },
                                    float: "right",
                                 }}
                                 variant="contained"
                                 size="large"
                                 //disabled={!isRestrictedAccess}
                                 onClick={handleAllocate}
                              >
                                 Allocate
                              </Button>
                           </Box>
                        </Grid>
                        <Grid
                           container
                           columns={12}
                           justifyContent="space-between"
                           alignItems="center"
                           spacing={2}
                           pb={2}
                        >
                           <Grid item xs={12} sm={12} md={12} lg={12}>
                              <TextField
                                 variant="outlined"
                                 label="Select Product"
                                 select={listProduct.length > 0 ? true : false}
                                 value={
                                    listProduct.length > 0
                                       ? selectedProduct.packGroupOrSKUID
                                       : 0
                                 }
                                 onChange={handleSelectProduct}
                                 size="small"
                                 fullWidth
                                 disabled={listProduct.length > 0 ? false : true}
                              >
                                 {listProduct.length > 0
                                    ? listProduct.map((item, index) => {
                                       return (
                                          <MenuItem
                                             key={item.packGroupOrSKUID}
                                             value={item.packGroupOrSKUID}
                                          >
                                             {item.packGroupOrSKUName}
                                          </MenuItem>
                                       );
                                    })
                                    : null}
                              </TextField>
                           </Grid>
                           <Grid item xs={12} sm={12} md={12} lg={12}>
                              <Box sx={{ display: 'flex', justifyContent: 'align-start', alignItems: 'center' }}>
                                 <TextField
                                    variant="outlined"
                                    label="Safety Margin"
                                    value={commonSafetyMargin?.toLocaleString('en-US')}
                                    onChange={handleSafetyMargin}
                                    size="small"
                                    fullWidth
                                    sx={{ mr: 2 }}
                                 ></TextField>
                                 <Box justifyContent="center" display="flex">
                                    <Button
                                       sx={{
                                          bgcolor: "darkBlue.light",
                                          color: "white.main",
                                          fontWeight: "700",
                                          textTransform: "none",
                                          "&:hover": {
                                             bgcolor: "darkBlue.main",
                                          },
                                          minWidth: "56px !important", // Reduced minWidth 
                                          padding: '2px 8px',
                                          height: "42px !important"
                                       }}
                                       variant="contained"
                                       //disabled={!isRestrictedAccess}
                                       onClick={applySafetyMargin}
                                    >
                                       Apply
                                    </Button>
                                 </Box>
                              </Box>
                           </Grid>
                           <Grid item xs={12} sm={12} md={12} lg={12}>
                              <Box sx={{ display: 'flex', justifyContent: 'align-start', alignItems: 'center' }}>
                                 <TextField
                                    variant="outlined"
                                    label="Rounder"
                                    value={rounder?.toLocaleString('en-US')}
                                    onChange={handleRounder}
                                    size="small"
                                    fullWidth
                                    sx={{ mr: 2 }}
                                 ></TextField>
                                 <Box justifyContent="center" display="flex">
                                    <Button
                                       sx={{
                                          bgcolor: "darkBlue.light",
                                          color: "white.main",
                                          fontWeight: "700",
                                          textTransform: "none",
                                          "&:hover": {
                                             bgcolor: "darkBlue.main",
                                          },
                                          minWidth: "56px !important", // Reduced minWidth 
                                          padding: '2px 8px',
                                          height: "42px !important"
                                       }}
                                       variant="contained"
                                       //disabled={!isRestrictedAccess}
                                       onClick={applyRounder}
                                    >
                                       Apply
                                    </Button>
                                 </Box>
                              </Box>
                           </Grid>
                           <Grid item xs={12} sm={12} md={12} lg={12}>
                              <Box sx={{ display: 'flex', justifyContent: 'align-start', alignItems: 'center' }}>
                                 <TextField
                                    variant="outlined"
                                    label="Buffer Adjustment"
                                    value={bufferAdjustment?.toLocaleString('en-US')}
                                    onChange={handleBufferAdjustment}
                                    size="small"
                                    fullWidth
                                    sx={{ mr: 2 }}
                                 ></TextField>
                                 <Box justifyContent="center" display="flex">
                                    <Button
                                       sx={{
                                          bgcolor: "darkBlue.light",
                                          color: "white.main",
                                          fontWeight: "700",
                                          textTransform: "none",
                                          "&:hover": {
                                             bgcolor: "darkBlue.main",
                                          },
                                          minWidth: "56px !important", // Reduced minWidth 
                                          padding: '2px 8px',
                                          height: "42px !important"
                                       }}
                                       variant="contained"
                                       //disabled={!isRestrictedAccess}
                                       onClick={applyBufferAdjustment}
                                    >
                                       Apply
                                    </Button>
                                 </Box>
                              </Box>
                           </Grid>
                           <Grid item xs={12} sm={12} md={12} lg={12}>
                              <TextField
                                 variant="outlined"
                                 label={`Revised ${TERMS.QUOTA}`}
                                 readOnly={true}
                                 value={revisedQuota?.toLocaleString('en-US')}
                                 size="small"
                                 fullWidth
                              ></TextField>
                           </Grid>
                        </Grid>
                     </Grid>
                     <Grid item xs={12} sm={12} md={9.35} lg={9.85}
                        sx={{ borderLeft: 1, borderColor: "#c6c6c6", paddingTop: "0px !important" }} >
                        <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }}  justifyContent="space-between" alignItems="center" sx={{ p: 0 }}>
                           <Box flex="1 1 27%">{loadQuotaChart && <ChartTableToggle />}</Box>
                           <Box flex="1 1 73%" className="quota_details_layout">
                              <Grid
                                 container
                                 columns={12}
                                 justifyContent="space-around"
                                 columnGap={1}
                              >
                                 <Grid item xs={5} lg={2.5}>
                                    <Typography className="quota_numbers">
													{ForecastAdjustment?.toLocaleString('en-US')}
													<Typography className="quota_labels">Forecast Adjustment</Typography>
												</Typography>
                                 </Grid>
                                 <Grid item xs={5} lg={2.5}>
                                    <Typography className="quota_numbers">
													{TotalAdjustment?.toLocaleString('en-US')}
													<Typography className="quota_labels">Customers Adjustment</Typography>
												</Typography>
                                 </Grid>
                                 <Grid item xs={5} lg={1.5}>
                                 <Typography className="quota_numbers">
													{TotalTender?.toLocaleString('en-US')}
													<Typography className="quota_labels">Tender</Typography>
											</Typography>
                                 </Grid>
                                 <Grid item xs={5} lg={2}>
                                    <Typography className="quota_numbers">
                                       {TotalSafetyMargin?.toLocaleString('en-US')}
                                       <Typography className="quota_labels">
                                          Total Safety Margin
                                       </Typography>
                                    </Typography>
                                 </Grid>
                                 {/* <Grid item xs={5} lg={2}>
                                    <Typography className="quota_numbers">
                                       {TotalUnusedQuota?.toLocaleString('en-US')}
                                       <Typography className="quota_labels">
                                          Total Unused {TERMS.QUOTA}
                                       </Typography>
                                    </Typography>
                                 </Grid> */}
                                 <Box
                                    sx={{
                                       height: "50px",
                                       width: "2px",
                                       backgroundColor: "#1976d2", // Blue shade
                                       margin: "0 16px",
                                       
                                    }}
                                 />
                                 <Grid item xs={5} lg={1.5}>
                                    <Typography className="quota_numbers">
                                       {TotalQuota?.toLocaleString('en-US')}
                                       <Typography className="quota_labels">
                                          Total {TERMS.QUOTA}
                                       </Typography>
                                    </Typography>
                                 </Grid>
                              </Grid>
                           </Box>
                        </Box>
                        {loadQuotaChart && <DefineQuotaChart />}
                        {loadQuotaChart && <DefineQuotaTable />}
                     </Grid>
                  </Grid>
               </CollapseSection>
            </>
         )
         }
         {
            loadQuotaDetails && (
               <>
                  {/* <Stack direction="row" alignItems="center" gap={2}>
                     <Typography
                        className="compHeading"
                        sx={{
                           color: "#007DC3",
                           fontWeight: "bold",
                           mt: 3,
                           width: "100%",
                        }}
                     >
                        <DownloadOutlined
                           sx={{ mt: 0, transform: "translate(0px, 8px)" }}
                           color="info"
                        />{" "}
                        Customer Breakdown
                     </Typography>
                  </Stack> */}
                  <CollapseSection sx={{ mt: 2 }} title="Supply Allocation">
                     <Box sx={!loadQuotaDetails && { display: "none" }}>
                        <ViewSearchRefresh />
                        <DefineQuotaBreakdown />
                     </Box>
                  </CollapseSection>
               </>
            )
         }

         {
            loadQuotaDetails && (
               <>
                  {/* {selectedQuota?.listQuotaFiles?.length > 0 && (
                     <Stack direction="row" alignItems="center" gap={2}>
                        <SpeakerNotesOutlined color="darkBlue.light" sx={{ mt: 4 }} />
                        <Typography
                           sx={{ color: "darkBlue.light", fontWeight: "bold", mt: 4 }}
                        >
                           Attachments
                        </Typography>
                     </Stack>
                  )} */}
                  <CollapseSection sx={{ mt: 2 }} title="Attachments">
                     <Table>
                        <TableBody>
                           {selectedQuota?.listQuotaFiles.map((row) => {
                              return (
                                 <TableRow className="tableRow" key={row?._id} width={'90%'}>
                                    <TableCell
                                       className="tableCell"
                                       sx={{ flexGrow: 1 }}
                                    >
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                       <Avatar sx={{ bgcolor: "darkBlue.light" }}>
                                          <InsertDriveFileIcon />
                                       </Avatar>
                                       <Box sx={{ ml: 2 }}>
                                          {row.filePath}
                                       </Box>
                                    </Box>
                                    </TableCell>
                                    <TableCell className="tableCell" width={'5%'}>
                                       <IconButton
                                          edge="start"
                                          aria-label="download"
                                          onClick={() => handleDownloadFile(row.filePath)}
                                       
                                       >
                                          <DownloadRoundedIcon />
                                       </IconButton>
                                    </TableCell>
                                    <TableCell className="tableCell" width={'5%'}>
                                       <IconButton
                                          edge="end"
                                          aria-label="delete"
                                          onClick={() => handleDeleteFile(row)}
                                          sx={{mr : 2}}
                                       >
                                          <DeleteIcon />
                                       </IconButton>
                                      
                                    </TableCell>
                                 </TableRow>
                              );
                           })}
                        </TableBody>
                     </Table>
                     <FileAttach />
                     <Attachments />
                  </CollapseSection>
                  <CollapseSection sx={{ mt: 2 }} title="Comments">
                     <Comments />
                  </CollapseSection>
                  <Grid container columns={12} justifyContent="flex-start" my={4}>
                     <Grid item xs={6} sm={2} md={2} lg={1.5}>
                        <Button
                           sx={{
                              bgcolor: "darkBlue.light",
                              color: "white.main",
                              fontWeight: "700",
                              textTransform: "none",
                              "&:hover": {
                                 bgcolor: "darkBlue.main",

                              },
                              ml: 1
                           }}
                           variant="contained"
                           //disabled={!isRestrictedAccess}
                           startIcon={<UploadOutlined />}
                           onClick={handleUploadQuota}
                        >
                           Upload {TERMS.QUOTA}
                        </Button>
                     </Grid>
                     <Grid item xs={6} sm={2} md={2} lg={1.6}>
                        <Button
                           sx={{
                              bgcolor: "darkBlue.light",
                              color: "white.main",
                              fontWeight: "700",
                              textTransform: "none",
                              "&:hover": {
                                 bgcolor: "darkBlue.main",

                              },
                           }}
                           variant="contained"
                           startIcon={<DownloadOutlined />}
                           onClick={handleDownloadQuota}
                        >
                           Download {TERMS.QUOTA}
                        </Button>
                     </Grid>
                  </Grid>
                  <Box my={2} />
                  <Grid
                     container
                     columns={12}
                     spacing={1}
                     justifyContent="flex-end"
                     alignItems="right"
                     my={2}
                  >
                     <Grid item xs={6} sm={2} md={2} lg={1.3}>
                        <Button
                           sx={{
                              bgcolor: "grey.lighter",
                              color: "darkBlue.light",
                              boxShadow: "none",
                              "&:hover": {
                                 bgcolor: "darkBlue.main",
                                 color: "white.main",
                                 border: "none",
                              },
                           }}
                           variant="contained"
                           startIcon={<SaveOutlined />}
                           onClick={handleSaveQuota}
                           disabled={onSubmitDisabled || !isRestrictedAccess}
                        >
                           Save {TERMS.QUOTA}
                        </Button>
                     </Grid>
                     <Grid item xs={6} sm={2} md={2} lg={1.5}>
                        <Button
                           sx={{
                              bgcolor: "darkBlue.light",
                              color: "white.main",
                              fontWeight: "700",
                              textTransform: "none",
                              "&:hover": {
                                 bgcolor: "darkBlue.main",

                              },
                           }}
                           variant="contained"
                           startIcon={<TaskAltOutlined />}
                           onClick={handleSubmitQuota}
                           disabled={onSubmitDisabled || !isRestrictedAccess}
                        >
                           Submit {TERMS.QUOTA}
                        </Button>
                     </Grid>
                  </Grid>
                  <Box my={2} />
               </>
            )
         }

         <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isLoading}
         >
            <CircularProgress />
         </Backdrop>
         <SharedComponent />
         <Dialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            maxWidth="sm"
            fullWidth
         >
            <DialogTitle style={{ cursor: "move" }}>
               <Typography sx={{ color: "darkBlue.light", fontWeight: "700", fontSize: "18px !important" }}>
                  Upload {TERMS.QUOTA} </Typography>
               <IconButton
                  aria-label="close"
                  onClick={handleClose}
                  sx={{
                     position: "absolute",
                     right: 8,
                     top: 8,
                     color: "darkBlue.light",
                  }}
               >
                  <Close />
               </IconButton>
            </DialogTitle>
            <DialogContent
               sx={{
                  paddingTop: "5px !important",
                  paddingBottom: "12px !important",
               }}
            >
               <div className="dropzone-container">
                  <Dropzone
                     onDrop={onDrop}
                     multiple={false}
                  // accept = {["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"]}
                  >
                     {({ getRootProps, getInputProps }) => (
                        <section className="dropzone">
                           <div {...getRootProps({})}>
                              <input {...getInputProps()} />
                              {selectedFiles && selectedFiles[0].name ? (
                                 <div className="selected-file">
                                    {selectedFiles && selectedFiles[0].name}
                                 </div>
                              ) : (
                                 <div>
                                    <UploadFile fontSize="medium" />
                                    <div>Drag file here or click to browse</div>
                                 </div>
                              )}
                           </div>
                        </section>
                     )}
                  </Dropzone>
               </div>
            </DialogContent>
            <DialogActions sx={{ padding: "12px 24px !important" }}>
               <Button onClick={handleClose}
                  sx={{
                     my: 0.5,
                     bgcolor: "grey.lighter",
                     color: "darkBlue.light",
                     // height: "40px",
                     // fontSize: "14px",
                     boxShadow: "none",
                     "&:hover": {
                        bgcolor: "darkBlue.main",
                        color: "white.main",
                        border: "none",
                     },
                  }}>Cancel</Button>
               <Button
                  sx={{
                     bgcolor: "darkBlue.light",
                     color: "white.main",
                     fontWeight: "700",
                     textTransform: "none",
                     "&:hover": {
                        bgcolor: "darkBlue.main",

                     },
                  }}
                  variant="contained"
                  onClick={handleProcess}
                  type="submit"
               >
                  Process
               </Button>
            </DialogActions>
         </Dialog>
      </Box >
      /* </form> */
   );
}

export default DefineQuota;
